import React from "react";
import {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListBody,
  StructuredListRow,
  StructuredListCell,
  TooltipDefinition,
} from "carbon-components-react";

const styles = require("./styles.module.scss");

export interface ColHeader {
  displayName: string;
  dataKey: string;
  tooltip?: string;
  align?: "right" | "left" | "center";
}

interface Props {
  title?: string;
  colHeaders: ColHeader[];
  rowData: any[]; // TODO make this better w./ rowData typing off of ColHeader
  tooltip?: string;
  action?: any;
}

const LabeledStructuredList: React.FC<Props> = ({
  title,
  colHeaders,
  rowData,
  tooltip,
  action,
}) => {
  return (
    <div className={styles.labeledStructuredList}>
      <div className={styles.listHeading}>
        {title && !tooltip ? (
          <h3>{title}</h3>
        ) : (
          <TooltipDefinition tooltipText={tooltip}>
            <h3>{title}</h3>
          </TooltipDefinition>
        )}
        <div>{action}</div>
      </div>
      <StructuredListWrapper>
        <StructuredListHead>
          <StructuredListRow head>
            {colHeaders.map(({ displayName, dataKey, tooltip: colHeadersToolTip }) => {
              return (
                <StructuredListCell head key={dataKey}>
                  {!colHeadersToolTip ? (
                    displayName
                  ) : (
                    <TooltipDefinition tooltipText={colHeadersToolTip}>
                      {displayName}
                    </TooltipDefinition>
                  )}
                </StructuredListCell>
              );
            })}
          </StructuredListRow>
        </StructuredListHead>
        <StructuredListBody>
          {rowData.map((row, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <StructuredListRow key={i}>
              {colHeaders.map(({ dataKey, align = "left" }) => {
                return (
                  <StructuredListCell
                    key={`${dataKey}}`}
                    className={styles[`textAlign${align.charAt(0).toUpperCase() + align.slice(1)}`]}
                  >
                    {row[dataKey] !== undefined ? row[dataKey] : "--"}
                  </StructuredListCell>
                );
              })}
            </StructuredListRow>
          ))}
        </StructuredListBody>
      </StructuredListWrapper>
    </div>
  );
};

export default LabeledStructuredList;
